import {useTranslation} from 'react-i18next'
import {Language} from '../core/entitites'

const languageList: Language[] = ['en', 'ro', 'bg']

const useLanguageSelect = () => {
    const {i18n} = useTranslation()
    const onChangeLanguage = (lang: string | number) => {
        void i18n.changeLanguage(lang.toString())
    }
    const language = i18n.language
    return {language, languageList, onChangeLanguage}
}

export default useLanguageSelect
